<template>
  <div id="orDetails">
    <ul class="from">
      <li class="fromItem">
        <div class="key">机构名称</div>
        <div class="value">
          <span>{{ orInfo.name }}</span>
          <!--          <span>{{ userData.idCard }}</span>-->
          <div style="display: inline-block">已完成实名认证，无法修改</div>
          <!--          <img src="@/assets/img/userInfo/bi.png" alt="" />-->
        </div>
      </li>
      <li class="fromItem">
        <div class="key">形象图</div>
        <div class="value">
          <img class="img" v-lazy="$global.imgUrl + orInfo.coverImg" alt />
          <Upload
            class="upload"
            accept=".png,.jpg,.jpeg"
            :headers="{ token: token }"
            :show-upload-list="false"
            :max-size="1024"
            :on-exceeded-size="handleMaxSize"
            :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
            :on-success="handleSuccess"
          >
            <img src="@/assets/img/userInfo/bi.png" v-if="edit" alt />
          </Upload>
        </div>
      </li>
      <li class="fromItem">
        <div class="key">主管单位</div>
        <div class="value">
          <span>{{ orInfo["company"] }}</span>
          <img
            @click="end"
            src="@/assets/img/userInfo/bi.png"
            v-if="edit"
            alt
          />
        </div>
      </li>
    </ul>
    <div class="btn">
      <div
        v-if="!edit"
        @click="setEdit"
        :class="orInfo.reviewStatus === 2 ? 'close' : 'affirm'"
      >
        {{ orInfo.reviewStatus | reviewStatusFilter }}
      </div>
      <div v-if="edit" @click="back" class="close">取消</div>
      <Button v-if="edit" v-throttleClick @click="sub" class="affirm">保存</Button>
    </div>
    <Modal
      :scrollable="true"
      v-model="alert"
      width="572px"
      class-name="vertical-center-modal"
      :footer-hide="true"
    >
      <div class="alert">
        <div class="title">请编辑主管单位</div>
        <div class="content">
          <template>
            <Input
              v-model="orInfo['company']"
              style="width: 462px; margin-left: 57px; margin-top: 20px"
              :placeholder="`请输入主管单位`"
            />
          </template>
        </div>

        <div class="btn">
          <div @click="closeAlert" class="close">取消</div>
          <Button v-throttleClick @click="affirm" class="affirm">保存</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["orgPeriodical", "orInfo"],
  name: "orDetails",
  computed: {
    ...mapState(["token"]),
  },
  data() {
    return {
      alert: false,
      edit: false,
      imgObj: null,
      value: "",
    };
  },
  methods: {
    closeAlert() {
      this.alert = false;
    },
    affirm() {
      if (this.orInfo.company === '') {
        this.$Message.error('请填写主管单位')
        return
      }
      this.alert = false;
    },
    async end() {
      this.alert = true;
      // console.log(this.orgPeriodical);
      // let res  =await this.$apis.userServe.setName()
      // console.log(res);
    },
    back() {
      this.$emit("getDetails");
      this.edit = false;
    },
    async sub() {
      if (this.orInfo["coverImg"] === undefined || this.orInfo["coverImg"] === '') {
        this.$Message.error('请上传形象图')
        return
      } else if (this.orInfo.company === '') {
        this.$Message.error('请填写主管单位')
        return
      }
      if (this.imgObj) {
        let obj = {
          fastIds: [this.imgObj.id],
          org: {
            coverImg: this.orInfo["coverImg"],
            company: this.orInfo["company"],
          },
        };
        await this.$apis.userServe.setName(obj);
        let data = await this.$apis.loginServe.getUserInfo();
        let userObj = {
          token: sessionStorage.getItem("token"),
          hasLogin: true,
          userInfo: data.content,
        };
        this.$store.commit("loginInfo", userObj);
        this.back();
      } else {
        let obj = {
          fastIds: [],
          org: {
            company: this.orInfo["company"],
          },
        };
        await this.$apis.userServe.setName(obj);
        let data = await this.$apis.loginServe.getUserInfo();
        let userObj = {
          token: sessionStorage.getItem("token"),
          hasLogin: true,
          userInfo: data.content,
        };
        this.$store.commit("loginInfo", userObj);
        this.back();
      }
      this.edit = false;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    handleSuccess(res) {
      this.imgObj = {
        fastId: res.content.id,
        fastPath: res.content.url,
      };
      this.$set(this.orInfo, 'coverImg', res.content.url)
    },
    setEdit() {
      this.edit = true;
    },
  },
  filters: {
    reviewStatusFilter(num) {
      if (num === 0) {
        return "审核中";
      } else if (num === 1) {
        return "待认领";
      } else if (num === 2) {
        return "编辑";
      } else {
        return "不通过";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alert {
  .subject::-webkit-scrollbar {
    width: 4px;
  }

  .subject::-webkit-scrollbar-thumb {
    width: 4px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .subject::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .subject {
    height: 200px;
    overflow-y: scroll;
  }

  .titleItem {
    margin-left: 77px;
    margin-top: 50px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    height: 25px;
    font-size: 24px;
  }

  .btn {
    margin-top: 34px;
    width: 100%;
    height: 120px;
    //background: pink;
    display: flex;
    align-items: center;
    justify-content: center;

    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }

    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 36px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }

  .addList {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    div {
      width: 20%;
      //background: pink;
      position: relative;

      span {
        position: absolute;
        top: -10px;
        right: 40px;
        width: 3px;
        height: 3px;
        display: block;
        font-size: 3px;
        cursor: pointer;
      }
    }
  }

  .leaveOne {
    margin-left: 57px;
    margin-top: 20px;

    width: 80%;
    display: flex;
    flex-wrap: wrap;

    .oneItem {
      //text-align: center;

      height: 50px;
      //background: pink;
      width: 25%;
    }

    .threeItem {
      margin-top: 20px;
      width: 100%;

      .name {
        //width: 54px;
        display: inline-block;
      }
    }

    .twoItem {
      margin-top: 20px;
      width: 25%;

      .name {
        //width: 54px;
        display: inline-block;
      }
    }
  }

  .title {
    margin-left: 57px;
    margin-top: 50px;
    height: 25px;
    font-size: 24px;
    //background: yellow;
    font-family: Microsoft YaHei;
    font-weight: 900;
    color: #333333;
    line-height: 24px;
  }
}

.btn {
  width: 1200px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: 420px;
  height: 50px;
  //background: pink;
  .close {
    text-align: center;
    line-height: 38px;
    width: 72px;
    height: 38px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    border-radius: 8px;
    margin-right: 13px;
    cursor: pointer;
  }

  .affirm {
    margin-left: 13px;
    text-align: center;
    line-height: 36px;
    width: 70px;
    height: 36px;
    color: #fff;
    background: #007fff;
    border-radius: 8px;
    cursor: pointer;
  }
}

#orDetails {
  margin-top: 15px;
  width: 1200px;
  min-height: 790px;
  padding-top: 50px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);

  .upload {
    display: inline-block;
  }

  .from {
    margin-left: 70px;
    margin-bottom: 30px;

    .fromItem {
      display: flex;
      min-height: 50px;
      margin-bottom: 10px;

      .key {
        width: 105px;
      }

      .value {
        span {
          margin-right: 20px;
        }

        img {
          cursor: pointer;
        }

        div {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }

        .img {
          width: 70px;
          height: 98px;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
